import axiosInstance from "@/api/axios-instance";

export interface SessionMapping {
  session_id: string;
  bundle_usage_id: string;
}

export async function mapSessions(
  mappings: SessionMapping[]
): Promise<{ success: boolean; mapped: number }> {
  const response = await axiosInstance.patch("/audit/map-sessions", {
    mappings,
  });
  return response.data;
}
